import { Component, Input } from '@angular/core';

@Component({
    selector: 'sbi-cot-table-sort-header',
    templateUrl: './table-sort-header.component.html',
    styleUrls: ['./table-sort-header.component.scss'],
    standalone: false
})
export class TableSortHeaderComponent {
  // Inputs
  @Input() label: string;
  @Input() orderCriteria: string;
  @Input() currentTableOrder: string;

  // Constructor
  constructor() {}
}
